import ExtendableError from '@/core/shared/misc/errorTypes';
export class InteropNotDefinedError extends ExtendableError {}
